module.exports = __webpack_public_path__ + "img/join-us-9.df3954b3.png";